import { getAdminEndpoint, getEndpointWithId } from 'helpers';

const pagePath = '/survey';
const schedulingPath = '/surveys';
const surveyRoles = '/roles';

const schedulingSurveyPath = `${schedulingPath}/:replaceSurveyId`;
const companies = '/clients/all/short';
const offices = '/clients/countEmployeesInOffices/{{clientId}}';
const surveyLimits = '/clients/surveyLimits/{{clientId}}';

export const CONSTANTS_TEMPLATES = {
	baseUrl: getAdminEndpoint(pagePath),
	schedulingUrl: getAdminEndpoint(schedulingPath),
	companiesUrl: getAdminEndpoint(companies),
	officesUrl: getAdminEndpoint(offices),
	limitsUrl: getAdminEndpoint(surveyLimits),
	rolesUrl: getAdminEndpoint(pagePath + surveyRoles),
	plannedSurveyUrl: getEndpointWithId(getAdminEndpoint(schedulingSurveyPath)),
};

export const selectOptions = {
	REMINDER_FREQUENCY: [
		{ title: 'Day', value: 'day' },
		{ title: 'Two Days', value: 'two day' },
	],
	DAY: 'day',
	ROUND_FREQUENCY: [
		{ title: 'Weekly', value: 'WEEKLY' },
		{ title: 'Monthly', value: 'MONTHLY' },
		{ title: 'Bi-monthly', value: 'BI_MONTHLY' },
		{ title: 'Quarterly', value: 'QUARTERLY' },
		{ title: 'Twice-annual', value: 'TWICE_ANNUAL' },
		{ title: 'Annual', value: 'ANNUAL' },
	],
	ROUND_LENGTH: [
		{ title: 'One week', value: '1' },
		{ title: 'Two weeks', value: '2' },
	],
};
